module.exports = __webpack_public_path__ + "static/media/urinera.9e8d0268.mp3";